import { render, staticRenderFns } from "./EmailEditor.vue?vue&type=template&id=b4413a38&scoped=true&"
import script from "./EmailEditor.vue?vue&type=script&lang=js&"
export * from "./EmailEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmailEditor.vue?vue&type=style&index=0&id=b4413a38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4413a38",
  null
  
)

export default component.exports